export default __webpack_public_path__ + "static/media/data-analysis.eae89ab1.jpg";